import * as EventEmitter from 'eventemitter3';
import RecordType from '../data/RecordType';

export enum RecorderEvent {
  RecordingEnded = 'recording-ended',
  UploadProgressed = 'upload-progressed',
  ConversionProgressed = 'conversion-progressed',
  Complete = 'complete'
}

export enum RecordingState {
  Recording = 'Recording',
  Uploading = 'Uploading',
  Converting = 'Converting',
  Compressing = 'Compressing'
}

class Recorder extends EventEmitter {
  type = RecordType.None;
  hasCancelled = false;

  constructor() {
    super();
  }

  cancel() {
    this.hasCancelled = true;
  }

  getPosition(): number {
    return 0;
  }

  getSpectrum(): Uint8Array {
    return new Uint8Array([]);
  }

  getWaveform(): Uint8Array {
    return new Uint8Array([]);
  }

  get waitingForFrames(): boolean {
    return false;
  }

  on(event: RecorderEvent, fn: EventEmitter.ListenerFn, context?: any): this {
    return super.on(event, fn, context);
  }
  once(event: RecorderEvent, fn: EventEmitter.ListenerFn, context?: any): this {
    return super.once(event, fn, context);
  }
  removeListener(
    event: RecorderEvent,
    fn?: EventEmitter.ListenerFn,
    context?: any,
    once?: boolean
  ): this {
    return super.removeListener(event, fn, context, once);
  }
  off(
    event: RecorderEvent,
    fn?: EventEmitter.ListenerFn,
    context?: any,
    once?: boolean
  ): this {
    return super.off(event, fn, context, once);
  }
  removeAllListeners(event?: RecorderEvent): this {
    return super.removeAllListeners(event);
  }
  emit(event: RecorderEvent, ...args: Array<any>): boolean {
    return super.emit.apply(this, [event].concat(args));
  }
}

export default Recorder;



// WEBPACK FOOTER //
// ./src/video/Recorder.ts